import React from "react";
import { Reveal } from "./Reveal";
import { PATTERNS } from "./data";

const STEPS = ["Request", "Minimum proof", "Authority", "Receipt"];

export default function Patterns() {
  return (
    <section className="section section--patterns" id="patterns">
      <div className="wrap">
        <Reveal>
          <div className="sec-head">
            <span className="sec-kicker">A reusable pattern</span>
            <h2 className="sec-title">One governed decision. Many contexts.</h2>
            <p className="sec-sub">
              The shipment was one example. The same governed-decision pattern repeats wherever
              accountable action crosses organisations.
            </p>
          </div>
        </Reveal>

        <div className="patterns" data-testid="patterns">
          {PATTERNS.map((p, i) => (
            <Reveal key={i} delay={i * 0.08} className="pcard" data-testid={"pattern-" + i}>
              <div className="pcard__inner">
                <h3 className="pcard__title">{p.title}</h3>
                <p className="pcard__line">{p.line}</p>
                <div className="pcard__chips">
                  {STEPS.map((s, j) => (
                    <React.Fragment key={s}>
                      <span className="pchip">{s}</span>
                      {j < STEPS.length - 1 && <span className="pchip__sep">›</span>}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
